<template>
  <div class="card">
    <div class="card-header text-center">
      <h4 class="title">Select Date Range & Task Fields</h4>
    </div>
    <div class="card-body">
      <form>
        <div class="row">
          <div class="col-md-2"></div>
          <div class="col-md-4">
            <label>Date Range</label>
            <el-date-picker type="daterange"
                            unlink-panels
                            range-separator="-"
                            start-placeholder="Start date"
                            end-placeholder="End date"
                            data-vv-name="search"
                            v-validate="'required'"
                            v-model="query.dateRange"
                            :format="constants.DATE.FORMAT.DISPLAY"
                            :picker-options="datePickerConfig.dateRange"
                            placeholder="Date Range">
            </el-date-picker>
            <small class="text-danger" v-show="errors.has('dateRange')">
              {{ getError('dateRange') }}
            </small>
          </div>
          <div class="col-md-4">
            <label>Task Fields</label>
            <v-select
              name="taskFields"
              multiple
              v-model="query.selectedTaskFields"
              label="label"
              value="key"
              placeholder="Select one or more Task Fields"
              :options="availableTaskFields">
            </v-select>
            <small class="text-danger" v-show="errors.has('taskFields')">
              {{ getError('taskFields') }}
            </small>
          </div>
          <div class="col-md-2"></div>
        </div>
        <div class="text-center" style="margin-top: 12px;">
          <button :disabled="processing" class="btn btn-info btn-fill" @click.prevent="clearForm">
            Clear
          </button>
          <button type="submit" :disabled="processing || !dateRangeSelected" class="btn btn-info btn-fill btn-wd" @click.prevent="validateAndSubmit">
            Generate Report Data
          </button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
    <div v-if="processing">
      <div style="text-align: center;">
        <h6>Depending on how large of a date range you selected, it can take up to 5 minutes to generate reporting data.</h6>
        <h6>You can leave this screen and come back a bit later. You will see the Flexmonster report screen when the process has completed.</h6>
        <img src="static/img/loading.gif" />
      </div>
    </div>
  </div>
</template>
<script>
import Constants from 'src/utilities/constants'
import {OK} from 'http-status-codes'
import {notifyError, notifySuccess} from 'src/utilities/utils'
import {mapGetters} from 'vuex'
import {sync} from 'vuex-pathify'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import datePickerConfig from '@/components/UIComponents/DatePicker/datePickerConfig'

export default {
  components: {
    vSelect
  },
  computed: {
    query: sync('flexmonster@query'),
    ...mapGetters({
      allTaskFields: 'flexmonster/allTaskFields',
      indexName: 'flexmonster/indexName',
      user: 'security/user'
    }),
    availableTaskFields() {
      return this.allTaskFields.filter((field) => !this.query.selectedTaskFields.includes(field))
    },
    dateRangeSelected() {
      return this.query.dateRange.length > 0
    }
  },
  data() {
    return {
      constants: Constants,
      datePickerConfig,
      processing: false
    }
  },
  methods: {
    clearForm() {
      this.$store.commit('flexmonster/resetQuery')
    },
    async validateAndSubmit() {
      if (await this.$validator.validateAll()) {
        this.processing = true
        this.$store.commit('flexmonster/addToMapping')
        this.$store.commit('flexmonster/generateIndexName', this.user)
        const response = await this.$store.dispatch('flexmonster/generateReportData')
        if (OK === response.status) {
          this.processing = false
          notifySuccess(this, 'Reporting data generated successfully. Redirecting to reporting UI')
          this.goToFlexmonsterUI()
        } else {
          this.processing = false
          notifyError(this, 'Failed to generate reporting data', response.errors)
        }
      }
    },
    goToFlexmonsterUI() {
      this.$router.push('/admin/reports/flexmonster')
    },
    getError(fieldName) {
      return this.errors.first(fieldName)
    }
  },
  async mounted() {
    // index was previously generated - use it
    const storedIndexName = localStorage.getItem(Constants.FLEXMONSTER.LOCAL_STORAGE_KEY)
    if (storedIndexName) {
      if (!this.indexName) {
        this.$store.set('flexmonster/indexName', storedIndexName)
      }
      this.goToFlexmonsterUI()
    } else {
      const response = await this.$store.dispatch('flexmonster/fetchAllTaskFields')
      if (OK !== response.status) {
        notifyError(this, 'Failed to load dynamic fields')
      }
    }
  }
}

</script>

<style scoped>
  label {
    display: block;
  }
</style>
